module.exports = __webpack_public_path__ + "static/media/information.12dfbc98.svg";